'use strict';

import './SocialCarousel.less';

import React from 'react';
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';

import img01 from 'ck-website/graphics/testimonials/05.png';
import img02 from 'ck-website/graphics/testimonials/02.png';
import img03 from 'ck-website/graphics/testimonials/03.png';
import img04 from 'ck-website/graphics/testimonials/04.png';
import img05 from 'ck-website/graphics/testimonials/01.png';
import img06 from 'ck-website/graphics/testimonials/06.png';
import img07 from 'ck-website/graphics/testimonials/07.png';
import img08 from 'ck-website/graphics/testimonials/08.png';
import img09 from 'ck-website/graphics/testimonials/09.png';
import img10 from 'ck-website/graphics/testimonials/10.png';
import img11 from 'ck-website/graphics/testimonials/11.png';
import img12 from 'ck-website/graphics/testimonials/12.png';
import img13 from 'ck-website/graphics/testimonials/13.png';

export default class SocialCarousel extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			testimonial: 0
		};

		this.testimonials = [
			img01,
			img02,
			img03,
			img04,
			img05,
			img06,
			img07,
			img08,
			img09,
			img10,
			img11,
			img12,
			img13
		];
	}

	componentDidMount() {
		// Preload images
		this.testimonials.map(url => {
			const img = new Image();
			img.src = url;
		});
	}

	render() {
		const { testimonial } = this.state;

		const currentTestimonial = this.testimonials[testimonial];

		return (
			<div className="SocialCarousel">
				<div
					className="SocialCarousel__button SocialCarousel__button--left"
					onClick={() =>
						this.setState({
							testimonial: testimonial === 0 ? this.testimonials.length - 1 : testimonial - 1
						})
					}
				>
					<ReactCKImage name="carousel-left-button" />
				</div>
				<div
					className="SocialCarousel__button SocialCarousel__button--right"
					onClick={() =>
						this.setState({
							testimonial: testimonial === this.testimonials.length - 1 ? 0 : testimonial + 1
						})
					}
				>
					<ReactCKImage name="carousel-right-button" />
				</div>
				<a href="https://www.facebook.com/CodeKingdoms/">
					<img className="SocialCarousel__img" src={currentTestimonial} />
				</a>
			</div>
		);
	}
}
